import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/forms/templates/')({
  beforeLoad: () => {
    throw redirect({ to: '/template-engine/templates', replace: true });
  },
});
